import { Validator, ValidatorFn } from "@angular/forms";

export class FieldBase<T> {
  value: T | undefined;
  formControlName: string;
  label: string;
  controlType: string;
  inputType: string;
  style: any;
  required: boolean;
  disabled: boolean;
  onlyShow: boolean;
  validators: (Validator | ValidatorFn)[];
  selectorList?: any;
  selectorFields?: any;
  selectorId?: string;
  selectorItem?: string;
  selectorSendValue?: any;
  hide?: boolean;
  onlyUpperCase?: boolean;
  constructor(
    options: {
      value?: T;
      formControlName?: string;
      label?: string;
      inputType?: string;
      style?: any;
      required?: boolean;
      disabled?: boolean;
      onlyShow?: boolean;
      validators?: (Validator | ValidatorFn)[];
      selectorList?: any;
      selectorFields?: any;
      selectorId?: string;
      selectorItem?: string;
      selectorSendValue?: any;
      hide?: boolean;
      onlyUpperCase?: boolean;
    } = {}
  ) {
    this.value = options.value;
    this.formControlName = options.formControlName || null;
    this.label = options.label || "";
    this.inputType = options.inputType || "text";
    this.style = options.style ? options.style : {};
    this.required = !!options.required;
    this.disabled = !!options.disabled;
    this.onlyShow = !!options.onlyShow;
    this.validators = options.validators;
    this.selectorList = options.selectorList;
    this.selectorFields = options.selectorFields;
    this.selectorId = options.selectorId;
    this.selectorItem = options.selectorItem;
    this.selectorSendValue = options.selectorSendValue;
    this.hide = !!options.hide;
    this.onlyUpperCase = !!options.onlyUpperCase;
  }
}
